'use strict';

module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/helpers/isNaN.js
 ** module id = 665
 ** module chunks = 0
 **/